export default __webpack_public_path__ + "static/media/contact-profile.87912bbb.svg";